import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		navYs: false,
		navArr: [{
				name: '联系我们',
				to: '/contact',
				xz: false
			},
			{
				name: '新闻资讯',
				to: '/news',
				xz: false
			},
			{
				name: '资质荣誉',
				to: '/honor',
				xz: false
			},
			{
				name: '服务范围',
				to: '/range',
				xz: false
			},
			{
				name: '关于我们',
				to: '/about',
				xz: false,
				icon:require('../assets/minwode.png'),
				iconxz:require('../assets/minwodexz.png'),
			},
			{
				name: '成功案例',
				to: '/case',
				xz: false,
				icon:require('../assets/minanlizhanshiicon.png'),
				iconxz:require('../assets/minanlizhanshiiconxz.png'),
			},
			{
				name: '首页',
				to: '/',
				xz: false,
				icon:require('../assets/minshouyeicon.png'),
				iconxz:require('../assets/minshouyexz.png'),
			},
		],
		website:'http://www.sy-eray.com',
		contact:'',
		bannerCall:'',
	},
	mutations: {
		navOpacityNum(state, e) {
			state.navYs = e
		},
		tapNavItem(state, e) {
			// console.log(e)
			state.navArr.forEach(function(item) {
				item.xz = false
			})
			state.navArr[e].xz = true
		},
		path(state, e) {
			// console.log(e);
			state.navArr.forEach(function(item) {
				item.xz = false
				if (item.to == e) {
					item.xz = true
				}
				if (e.indexOf("/news/details") !== -1) {
					if (item.to == '/news') {
						item.xz = true
					}
				}

			})
		},
		contact(state,e){
			console.log('e',e)
			state.contact = e;
			state.bannerCall = e.tellphone.split('：')[1];
			// state.bannerCall = e.tellphone;
		}

	},
	actions: {

	},
	modules: {

	}
})
